import React from 'react';
import Spinner from '../generics/Spinner';
import AddInventoryWidget from '../generics/AddInventoryWidget';

const ProductionRecipe = (props) => {
  const instructions= props.recipe.instructions.replace(/(?:\r\n|\r|\n)/g, '<br/>')
  return (
    <div className="row">
      <div className="col-12 col-md-6">
        <div className="card">
          <div className="card-header card-header-inverse">
            <h4 className="mb-0">Ingredients</h4>
          </div>
          <div className="card-block pb-0">
              <h6>Quantity to be produced</h6>
              <div className="row">
                <div className="form-group col-10">
                    <div className="input-group">
                      <input placeholder="Quantity"
                        type="number"
                        className="z-index-0 form-control"
                        value={props.recipeAmount}
                        onBlur={props.onRecipeAmountBlur}
                        onChange={props.onRecipeAmountChange}/>
                      <div className="input-group-addon">{props.recipe.item.measure_unit ? props.recipe.item.measure_unit : 'lb' }</div>
                    </div>
                </div>
              </div>
          </div>
          <div className="card-block pb-0">
              <h6>Ingredients</h6>
              <ul>
                {props.recipe.ingredients.map((ing,index) => {
                    return(
                      <li key={ing.id}>
                        <span><strong>{ing.item.name}</strong> : {props.ingAmount[ing.item.id]} {ing.item.measure_unit}</span>
                      </li>)
                    })
                }
              </ul>
          </div>
          <div className="card-block pb-0">
              <h6>Scanning a label</h6>
              <AddInventoryWidget
                inputVal={props.inventoryToAdd}
                onInputChange={props.onInventoryToAddChange}
                onSubmit={props.onInventoryAddSubmit}
                onScanItem={props.onScanItem}
                onScanError={props.onScanError}
                scanResult={props.scanResult}
                scanStatus={props.scanStatus}
              />
            {props.loadingIngredient ? <Spinner /> : null}
          </div>
        </div>
      </div>
      <div className="col-12 col-md-6">
        <div className="card">
          <div className="card-header card-header-inverse">
            <h4 className="mb-0">Instructions</h4>
          </div>
          <div className="card-block">
            <div dangerouslySetInnerHTML={{__html: instructions}}></div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProductionRecipe
